export default "__VITE_ASSET__be832436__"